var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FCD572"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2349 8.3231C15.5244 7.65223 16.4757 7.65223 16.7652 8.3231L18.5818 12.533C18.7044 12.8171 18.9743 13.0099 19.2828 13.0337L23.9417 13.3937C24.6891 13.4514 24.9861 14.3898 24.408 14.8671L20.9044 17.7599C20.6572 17.9639 20.549 18.2916 20.626 18.6027L21.7043 22.9596C21.8816 23.6761 21.1087 24.2524 20.4726 23.878L16.4228 21.4938C16.1619 21.3402 15.8382 21.3402 15.5773 21.4938L11.5275 23.878C10.8914 24.2524 10.1185 23.6761 10.2958 22.9596L11.3741 18.6027C11.4511 18.2916 11.3428 17.9639 11.0957 17.7599L7.59204 14.8671C7.01391 14.3898 7.31091 13.4514 8.0584 13.3937L12.7173 13.0337C13.0257 13.0099 13.2956 12.8171 13.4182 12.533L15.2349 8.3231Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d1409eacee669793eded0a28d9671184.svg";
export { ForwardRef as ReactComponent };